import React, { useState } from "react";

import "../css/LynxStyle.css";

const CYCLE_MINUTES = 90;
const FALL_ASLEEP_MINUTES = 14;

const SleepCalculator = () => {
  const [wakeTime, setWakeTime] = useState("");
  const [bedtimes, setBedtimes] = useState(null);

  const CalculateBedtimes = () => {
    if (!wakeTime) {
      return;
    }
    const [hours, minutes] = wakeTime.split(":").map(Number);
    const wake = new Date();
    wake.setHours(hours, minutes, 0, 0);

    const options = [6, 5, 4, 3].map((cycles) => {
      const bedtime = new Date(wake);
      bedtime.setMinutes(
        bedtime.getMinutes() - cycles * CYCLE_MINUTES - FALL_ASLEEP_MINUTES
      );
      return {
        cycles,
        hours: cycles * 1.5,
        time: bedtime.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      };
    });

    setBedtimes(options);
  };

  return (
    <div className="container">
      <br />
      <br />
      <h3 className="text-white">😴 Ideal Sleep Calculator</h3>
      <div className="lynx-page-card">
        <form>
          <div className="form-group">
            <label htmlFor="wakeTime" className="text-white">
              What time do you want to wake up?
            </label>
            <input
              type="time"
              value={wakeTime}
              onChange={(e) => setWakeTime(e.target.value)}
              className="form-control"
              id="wakeTime"
            />
          </div>
          <div className="text-center mt-3">
            <button
              type="button"
              onClick={CalculateBedtimes}
              className="btn-lynx w-100"
            >
              🌙 Calculate Bedtimes
            </button>
          </div>
        </form>
        {bedtimes && (
          <div className="smsgpt text-center mt-3 fs-5">
            Go to bed at one of these times to wake up refreshed:
            <table className="table table-bordered mt-3 text-white">
              <thead>
                <tr>
                  <th>Bedtime</th>
                  <th>Sleep Cycles</th>
                  <th>Total Sleep</th>
                </tr>
              </thead>
              <tbody>
                {bedtimes.map((b) => (
                  <tr key={b.cycles}>
                    <td>{b.time}</td>
                    <td>{b.cycles}</td>
                    <td>{b.hours} hrs</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <small>Based on ~90 minute sleep cycles + time to fall asleep</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default SleepCalculator;
